/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfPlatformModeDto } from '../../models/platform-api-result-of-platform-mode-dto';

export interface GetPlatformMode$Params {
}

export function getPlatformMode(http: HttpClient, rootUrl: string, params?: GetPlatformMode$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfPlatformModeDto>> {
  const rb = new RequestBuilder(rootUrl, getPlatformMode.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfPlatformModeDto>;
    })
  );
}

getPlatformMode.PATH = '/api/platform-mode';
